<nav class="subnav">
  <ul class="nav">
    <li class="nav-item" *ngIf="jobId === 0">
      <a class="nav-link active" [routerLink]="['/project/details/', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">Zum Projekt </a>
    </li>
    <li class="nav-item" *ngIf="jobId > 0">
      <a class="nav-link active" [routerLink]="['/job/details/', projectId, jobId]">Zum Job</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!positions">
  <h2>Order {{ projectId }}.0002.{{ orderId }}</h2>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Auftrag vom: {{ orders.order_date| date:'dd.MM.yyyy'  }}</span>
    <span class="label label-light-blue">Liefertermin: {{ orders.order_delivery | date:'dd.MM.yyyy' }}</span>
    <span class="label label-light-blue">Summe (netto): {{ orderTotal | currency: 'EUR':'code':'1.2-2':'de' }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}
      <clr-dropdown [clrCloseMenuOnItemClick]="true">
        <button clrDropdownTrigger aria-label="Dropdown demo button">
            <cds-icon shape="angle" direction="down"></cds-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen>
            <label class="dropdown-header" aria-hidden="true">Status ändern</label>
            <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
            <ng-container *ngFor="let item of statusButtons let i = index" >
              <div clrDropdownItem *ngIf="!item.locked"  (click)="changeOrderStatus(projectId, orderId, i)">
                {{ item.display }}
              </div>
            </ng-container>
        </clr-dropdown-menu>
    </clr-dropdown>
    </span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row" *ngIf="!loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          {{ orders.order_subject }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab *ngIf="!!deliveryAddress">
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-5">
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Auftragnehmer
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/contact/details', orders.order_cid ]"></cds-icon>
                        </div>
                        <div class="clr-col-5">
                          {{ orders.company_name }}<br />{{ orders.order_street }}<br />{{ orders.order_postcode }} {{ orders.order_city }}
                          <span *ngIf="orders.order_country !== 'Deutschland'">{{ orders.order_country }}</span>
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-6">
                          Ansprechpartner beim Auftragnehmer
                        </div>
                        <div class="clr-col-1">
                          <cds-icon shape="note" [routerLink]="['/person/details', orders.employee_order ]"></cds-icon>
                        </div>
                        <div class="clr-col-5">
                          {{ orders.order_salutation }} {{ orders.order_firstname}} {{ orders.order_lastname }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-7">
                          Angebotsnummer des Auftragnehmers
                        </div>
                        <div class="clr-col-5">
                          {{ orders.purchasing_id }}
                        </div>
                      </div>
                      <div class="clr-row" *ngIf="statusText !== 'Entwurf'">
                        <div class="clr-col-7">
                          Auftragsbestätigungsnummer des Auftragnehmers
                        </div>
                        <div class="clr-col-5">
                          {{ orders.order_confirmation_id }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-7">
                          Zahlungsbedingungen:
                        </div>
                        <div class="clr-col-5">
                          {{ paymentCondition }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-7">
                          Lieferung:
                        </div>
                        <div class="clr-col-5">
                          {{ deliveryCondition }}
                        </div>
                      </div>
                      <div *ngIf="deliveryConditionHasOption && deliveryAddress.length > 0" class="clr-row">
                        <div class="clr-col-7">
                          Lieferadresse:
                        </div>
                        <div class="clr-col-5">
                          {{ deliveryAddress[0].company }}<br />
                          {{ deliveryAddress[0].street }}<br />
                          {{ deliveryAddress[0].postcode }} {{ deliveryAddress[0].city }}<br />
                          {{ deliveryAddress[0].country }}
                        </div>
                      </div>
                      <div class="clr-row">
                        <div class="clr-col-7">
                          Bestellter Liefertermin:
                        </div>
                        <div class="clr-col-5">
                          {{ orders.order_delivery | date: 'dd.MM.yyyy' }}
                        </div>
                      </div>
                    </div>
                    <div class="clr-col-7">
                      <div class="clr-row">
                        <div class="clr-col-2">
                          Kommentare
                        </div>
                        <div class="clr-col-10">
                          <app-comment-feature-card [projectId]=projectId [companyId]=orders.order_cid [staffId]=orders.employee_phm [subId]=orderId [commentType]=2></app-comment-feature-card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/order/update', projectId, jobId, orderId]">Auftrag bearbeiten</button>
                    <button class="btn btn-warning" (click)="deleteOrder(projectId, orderId)">Auftrag löschen</button>
                  </div>
                  <ng-container *ngIf="editPos < 2">
                    <ng-container *ngIf="statusText === 'Entwurf'">
                      <clr-datagrid [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">

                        <clr-dg-action-bar *ngIf="statusText === 'Entwurf'">
                          <div class="btn-group">
                            <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Postionen löschen</button>
                          </div>
                        </clr-dg-action-bar>

                        <clr-checkbox-wrapper class="clr-checkbox-wrapper" *ngIf="statusText === 'Entwurf'">
                          <input clrcheckbox="" type="checkbox" aria-label="Select" id="clr-dg-row-cb31" class="ng-untouched ng-pristine ng-valid">
                          <label class="clr-control-label ng-star-inserted" for="clr-dg-row-cb31"></label>
                        </clr-checkbox-wrapper>

                        <clr-dg-column [clrDgField]="'position'">Position</clr-dg-column>
                        <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                        <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                        <clr-dg-column>Material</clr-dg-column>
                        <clr-dg-column>Kennzeichnung</clr-dg-column>
                        <clr-dg-column [clrDgField]="'specification'" style="width: 15%">Spezifikation</clr-dg-column>
                        <clr-dg-column>Bemerkungen</clr-dg-column>
                        <clr-dg-column>Label</clr-dg-column>
                        <clr-dg-column class="center">Anzahl</clr-dg-column>
                        <clr-dg-column class="currency">Angebot in EUR</clr-dg-column>
                        <clr-dg-column [clrDgField]="'delivery_date'" style="width: 220px" *ngIf="orders.order_status !== 'open'">Liefertermin (von Lieferant)</clr-dg-column>
                        <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                        <clr-dg-placeholder>We couldn't find any Position for Order {{ projectId }}.0002.{{ orderId }}!</clr-dg-placeholder>
                        <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                          <clr-dg-cell>{{ position.position_label || position.position }}<span *ngIf="(position.part ?? 0) > 0">.{{ position.part }}</span> </clr-dg-cell>
                          <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing ]">
                            <b>{{ position.name }}</b>
                            <clr-tooltip *ngIf="position.comment_phm">
                              <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                              <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                                <span>{{ position.comment_phm }}</span>
                              </clr-tooltip-content>
                            </clr-tooltip>
                            <span *ngIf="position.description"><br />{{ position.description }}</span>
                            <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                          </clr-dg-cell>
                          <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing ]">
                            {{ position.technical_drawing }}
                            <span *ngIf="!position.active"><br /><br /><button *ngIf="!position.active" class="btn btn-warning btn-sm">PASSIV! {{ warnPassiv() }}</button></span>
                          </clr-dg-cell>
                          <clr-dg-cell>{{ position.material }}
                            <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                            <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                          </clr-dg-cell>
                          <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span></clr-dg-cell>
                          <clr-dg-cell>
                            <span *ngIf="position.specification">{{ position.specification }}</span>
                          </clr-dg-cell>
                          <clr-dg-cell>
                            <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                            <span *ngIf="position.side_agreements"><b>Nebenabreden (Lieferant):</b> {{ position.side_agreements }}</span>
                          </clr-dg-cell>
                          <clr-dg-cell><cds-icon shape="printer" (click)="printLabel(position)"></cds-icon></clr-dg-cell>
                          <clr-dg-cell class="center">
                              <span *ngIf="!position.technology">
                                {{ position.number_of_pieces }}
                              </span>
                          </clr-dg-cell>
                          <clr-dg-cell class="right currency"><b>{{ position.budget | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                          <clr-dg-cell *ngIf="orders.order_status !== 'open'">
                            <span *ngIf="((position.delivery_date) && (position.delivery_date !== '2020-01-01'))">{{ position.delivery_date | date: 'dd.MM.yyyy' }}</span><br>
                            <app-order-details-warehouse-short [projectId]="projectId" [jobId]="jobId" [orderId]="orderId" [positionId]="position.position" [partId]="position.part ?? 0"></app-order-details-warehouse-short>
                          </clr-dg-cell>
                          <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                            <button class="btn btn-sm" (click)="updatePositionMode(i, position.position, position.part ?? 0)">
                              <cds-icon shape="pencil"></cds-icon>
                              <span class="clr-icon-title">Ändern</span>
                            </button>
                          </clr-dg-cell>
                        </clr-dg-row>
                        <clr-dg-footer>
                          <clr-dg-pagination #pagination [clrDgPageSize]="50">
                            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                            von {{positions.length}} Position(en)
                          </clr-dg-pagination>
                        </clr-dg-footer>
                      </clr-datagrid>
                    </ng-container>


                    <ng-container *ngIf="statusText !== 'Entwurf'">
                      <clr-datagrid [clrDgLoading]="loading2">
                        <clr-dg-column [clrDgField]="'position'">Position</clr-dg-column>
                        <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                        <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                        <clr-dg-column>Material</clr-dg-column>
                        <clr-dg-column>Kennzeichnung</clr-dg-column>
                        <clr-dg-column style="width: 15%">Spezifikation</clr-dg-column>
                        <clr-dg-column>Bemerkungen</clr-dg-column>
                        <clr-dg-column>Label</clr-dg-column>
                        <clr-dg-column class="center">Anzahl</clr-dg-column>
                        <clr-dg-column class="currency">Angebot in EUR</clr-dg-column>
                        <clr-dg-column [clrDgField]="'delivery_date'" style="width: 220px" *ngIf="orders.order_status !== 'open'">Liefertermin (von Lieferant)</clr-dg-column>
                        <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                        <clr-dg-placeholder>We couldn't find any Position for Order {{ projectId }}.0002.{{ orderId }}!</clr-dg-placeholder>
                        <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                          <clr-dg-cell>{{ position.position_label || position.position }}<span *ngIf="(position.part ?? 0) > 0">.{{ position.part }}</span> </clr-dg-cell>
                          <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing ]">
                            <b>{{ position.name }}</b>
                            <clr-tooltip *ngIf="position.comment_phm">
                              <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                              <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                                <span>{{ position.comment_phm }}</span>
                              </clr-tooltip-content>
                            </clr-tooltip>
                            <span *ngIf="position.description"><br />{{ position.description }}</span>
                            <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                          </clr-dg-cell>
                          <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing ]">
                            {{ position.technical_drawing }}
                            <span *ngIf="!position.active"><br /><br /><button *ngIf="!position.active" class="btn btn-warning btn-sm">PASSIV! {{ warnPassiv() }}</button></span>
                          </clr-dg-cell>
                          <clr-dg-cell>{{ position.material }}
                            <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                            <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                          </clr-dg-cell>
                          <clr-dg-cell><span *ngIf="position.serial_nr !== 'null'">{{ position.serial_nr }}</span></clr-dg-cell>
                          <clr-dg-cell>
                            <span *ngIf="position.specification"><b>Spezifikation:</b> {{ position.specification }}</span>
                          </clr-dg-cell>
                          <clr-dg-cell>
                            <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                            <span *ngIf="position.side_agreements"><b>Nebenabreden (Lieferant):</b> {{ position.side_agreements }}</span>
                          </clr-dg-cell>
                          <clr-dg-cell><cds-icon shape="printer" (click)="printLabel(position)"></cds-icon></clr-dg-cell>
                          <clr-dg-cell class="center">
                              <span *ngIf="!position.technology">
                                {{ position.number_of_pieces }}
                              </span>
                          </clr-dg-cell>
                          <clr-dg-cell class="right currency"><b>{{ position.budget | currency: 'EUR':'code':'1.2-2':'de' }}</b></clr-dg-cell>
                          <clr-dg-cell *ngIf="orders.order_status !== 'open'">
                            <span *ngIf="((position.delivery_date) && (position.delivery_date !== '2020-01-01'))">{{ position.delivery_date | date: 'dd.MM.yyyy' }}</span><br>
                            <app-order-details-warehouse-short [projectId]="projectId" [jobId]="jobId" [orderId]="orderId" [positionId]="position.position" [partId]="position.part ?? 0"></app-order-details-warehouse-short>
                          </clr-dg-cell>
                          <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                            <button class="btn btn-sm" (click)="updatePositionMode(i, position.position, position.part ?? 0)">
                              <cds-icon shape="pencil"></cds-icon>
                              <span class="clr-icon-title">Ändern</span>
                            </button>
                          </clr-dg-cell>
                          <clr-dg-row-detail *clrIfExpanded clrLoading>
                            <app-order-details-warehouse-position [projectId]="projectId" [jobId]="jobId" [orderId]="orderId" [positionId]="position.position" [partId]="position.part ?? 0" [technicalDrawing]="position.technical_drawing" (updateParent)="onWarehouseUpdated()"></app-order-details-warehouse-position>
                          </clr-dg-row-detail>
                        </clr-dg-row>
                        <clr-dg-footer>
                          <clr-dg-pagination #pagination [clrDgPageSize]="50">
                            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                            von {{positions.length}} Position(en)
                          </clr-dg-pagination>
                        </clr-dg-footer>
                      </clr-datagrid>
                    </ng-container>
                  </ng-container>

                  <app-order-details-edit-position [projectId]="projectId" [jobId]="jobId" [orderId]="orderId" [editPosition]="positionId" [editPart]="partId" [orderStatus]="orders.order_status" [offerNr]="orders.order_confirmation_id" *ngIf="editPos === 2"  (updatedPosition)="updateOrder($event)"></app-order-details-edit-position>

                  <br *ngIf="(editPos === 1)"  />

                  <clr-dropdown *ngIf="((editPos === 1) && (statusText === 'Entwurf'))" [clrCloseMenuOnItemClick]="false">
                    <button clrDropdownTrigger class="dropdown-toggle btn btn-link" aria-label="Dropdown positions button">
                      Jobposition hinzufügen
                      <cds-icon shape="angle" direction="down"></cds-icon>
                    </button>
                    <clr-dropdown-menu *clrIfOpen>
                      <div clrDropdownItem *ngFor="let components of foundPositions" (click)="addRow(components.position, components.part ?? 0, components.technical_drawing, components.name)">{{ components.position }}.{{ components.part }}  {{ components.name }} ({{ components.technical_drawing }})</div>
                    </clr-dropdown-menu>
                  </clr-dropdown>

                  <br *ngIf="(editPos === 1)"  /><br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="basic = true; createOrder(positions)" [disabled]="disablePdf" [title]="pdfHinweis">PDF anzeigen</button>
                    <button *ngIf="editPos === 0" class="btn" (click)="editPos = 1;">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                    <button *ngIf="editPos === 0" class="btn" (click)="createTransportNote(projectId, orderId)">Transportschein erstellen</button>
                    <button *ngIf="editPos === 0" class="btn btn-primary btn-sm" (click)="createNotification(projectId, orderId, jobId)">Mitteilung</button>
                  </div>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-order-details-documents [projectId]="projectId" [orderId]="orderId" [jobId]="jobId"></app-order-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ orders.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>

  <h3 *ngIf="!!notification60">Mitteilungen an den Lieferanten</h3>
  <clr-datagrid *ngIf="!!notification60" [clrDgLoading]="loading3">
    <clr-dg-column [clrDgField]="'project_id'">Mitteilung</clr-dg-column>
    <clr-dg-column [clrDgField]="'project_id'">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Empfänger</clr-dg-column>
    <clr-dg-column [clrDgField]="'subject'">Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Notification!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let notification of notification60">
      <clr-dg-cell [routerLink]="['/notification/details/', notification.project_id, notification.job_id, notification.notification_id]">{{ notification.project_id }}.0007.{{ notification.notification_id }}</clr-dg-cell>
      <clr-dg-cell>{{ notification.notification_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
      <clr-dg-cell>{{ notification.company_name }}</clr-dg-cell>
      <<clr-dg-cell>{{ notification.subject }}</clr-dg-cell>
      <clr-dg-cell><b>{{ notification.name_project }}</b></clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{notification60.length}} Job(s)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>

  <app-order-transport [projectId]="projectId" [jobId]= "jobId" [orderId]="orderId"></app-order-transport>

  <h3>Zur Order gehörende Komponenten/Zeichnungen:</h3>

  <clr-datagrid [clrDgLoading]="loading3" [(clrDgSelected)]="selectedFiles">
    <clr-dg-action-bar *ngIf="selectedFiles.length > 0">
      <div class="btn-group">
        <button type="button" class="btn btn-sm btn-secondary" (click)="downloadZip(selectedFiles)">
          <cds-icon shape="download"></cds-icon> ZIP-Datei laden
        </button>
      </div>
    </clr-dg-action-bar>
    <clr-dg-column [clrDgField]="'position'">Position</clr-dg-column>
    <clr-dg-column [clrDgField]="'fileName'">Zeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'description'">Dateibeschreibung</clr-dg-column>
    <clr-dg-column>Hochgeladen am</clr-dg-column>

    <clr-dg-placeholder>Keine Dateien zur Order {{ projectId }}.0002.{{ orderId }} vorhanden!</clr-dg-placeholder>

    <clr-dg-row *clrDgItems="let filesB of componentsFiles" [clrDgItem]="filesB">
      <clr-dg-action-overflow>
        <button class="action-item" *ngIf="filesB.fileType === 'application/pdf'" (click)="showModal(filesB.id)">Show PDF</button>
        <button class="action-item" (click)="loadFile(filesB.id, filesB.fileName)">Download</button>
      </clr-dg-action-overflow>
      <clr-dg-cell>{{ filesB.position }}<span *ngIf="(filesB.part ?? 0) > 0">.{{ filesB.part }}</span></clr-dg-cell>
      <clr-dg-cell [routerLink]="['/component/details', filesB.technical_drawing]">{{ filesB.component_name }}<br /> <span class="small">{{ filesB.technical_drawing }}</span></clr-dg-cell>
      <clr-dg-cell>{{ filesB.description }}</clr-dg-cell>
      <clr-dg-cell>{{ filesB.time }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>Ausgewählte Dateien: {{ selectedFiles.length }}</clr-dg-footer>
  </clr-datagrid><br />

</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">BESTELLUNG {{ projectId }}.0002.{{ orderId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>

<ng-container *ngIf="showPdf">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>

<clr-modal [(clrModalOpen)]="showTransportModal" [clrModalSize]="'lg'">
  <h3 class="modal-title">Transportschein erstellen – Positionen auswählen</h3>
  <div class="modal-body">
    <p class="p6">Bitte wählen Sie die Lagerpositionen aus, die in den Transportschein übernommen werden sollen.</p>
    <clr-datagrid>
      <clr-dg-column style="width:60px">Pos.</clr-dg-column>
      <clr-dg-column style="width:50px">Teil</clr-dg-column>
      <clr-dg-column>Zeichnung / Bezeichnung</clr-dg-column>
      <clr-dg-column>Seriennummer</clr-dg-column>
      <clr-dg-column>Chargennummer</clr-dg-column>
      <clr-dg-column style="width:60px">Menge</clr-dg-column>
      <clr-dg-column style="width:100px">Auswahl</clr-dg-column>
      <clr-dg-row *ngFor="let item of transportSelectables">
        <clr-dg-cell>{{ item.position_no }}</clr-dg-cell>
        <clr-dg-cell>{{ item.part }}</clr-dg-cell>
        <clr-dg-cell>{{ item.technical_drawing || item.name || '—' }}</clr-dg-cell>
        <clr-dg-cell>{{ item.serial_nr || '—' }}</clr-dg-cell>
        <clr-dg-cell>{{ item.heat_nr || '—' }}</clr-dg-cell>
        <clr-dg-cell>{{ item.number_of_pieces }}</clr-dg-cell>
        <clr-dg-cell><input type="checkbox" clrCheckbox [checked]="selectedWarehouseIds.has(item.warehouse_id)" (change)="toggleWarehouseSelection(item.warehouse_id)" /></clr-dg-cell>
      </clr-dg-row>
    </clr-datagrid>
    <button class="btn btn-sm btn-link" (click)="selectAllWarehouses()">Alle auswählen</button>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline" (click)="showTransportModal = false">Abbrechen</button>
    <button class="btn btn-primary" [disabled]="selectedWarehouseIds.size === 0" (click)="confirmTransportModal()">Transportschein erstellen</button>
  </div>
</clr-modal>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Job-Positionen:</p>
  {{ foundPositions | json }}
</pre>
